const state = {
    items:[],
    datalist:[],
    comparelastcount: 0,
    latestfoundcount: 0,
    iscount:true
  };
  
  const mutations = {
  
  };
  
  const actions = {
  
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  
  


// WEBPACK FOOTER //
// ./src/store/outlink.js